import React, { RefObject } from "react";
import { Container, Divider, Sticky, Ref } from "semantic-ui-react";
import HeaderDefault from "./HeaderDefault";
import Routes from "./Routes";

export default class Principale extends React.Component {
    private contextRef: RefObject<HTMLInputElement>;

    constructor(props: {}) {
        super(props);

        this.contextRef = React.createRef();
    }

    render() {
        // il div è utilizzato perche il container fluid, in versione mobile, lascia dello spazio a destra e sinistra nel menu
        return (
            <div>
                <Sticky context={this.contextRef}>
                    <HeaderDefault />
                </Sticky>
                <Ref innerRef={this.contextRef}>
                    <Container fluid>
                        <Divider hidden />
                        <Routes />                        
                    </Container>
                </Ref>
            </div>
        );
    }
}
